import TncPage from "@/components/tnc/TncPage";
import { tncFooterNote, tncHero, tncSections } from "./tncContent";

export default function TermsAndConditions() {
  return (
    <TncPage
      hero={tncHero}
      sections={tncSections}
      footerNote={tncFooterNote}
      path="/izicart/tnc"
    />
  );
}
